// You can add new feature toggles in this enum, with the feature toggle name from GrandCentral as the value.
export enum FeatureToggles {
  DxaExample = 'dxaExample', // keep here for unit tests,
  ClientAppIntegrations = 'digitaldesktopClientAppIntegration',
  ChatTextFormatting = 'digitalDesktopChatTextFormatting',
  CobrowseV2 = 'cobrowse.v2',
  CobrowseInterapption = 'cobrowseV2-useEmbeddedInterapption',
  FacebookMessengerTextFormatting = 'digitalDesktopFacebookChatTextFormatting',
  WhatsAppTextFormatting = 'digitalDesktopWhatsAppChatTextFormatting',
  CardsAndCarousels = 'digitalDesktopCardsAndCarousels',
}

export type FeatureToggleValues = { [key in FeatureToggles]?: boolean };
